import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { suggestReply } from "@/api/data";
export default {
  props: {
    form: Object,
    serverList: Object
  },
  data: function data() {
    return {
      replyInput: "",
      status: false
    };
  },
  methods: {
    cellStyle: function cellStyle(_ref) {
      var columnIndex = _ref.columnIndex;
      if (columnIndex === 0) {
        return "colStyle";
      } else {
        return "notcolStyle";
      }
    },
    cancelBtn: function cancelBtn() {
      this.$emit("backBtn", false);
    },
    confirmBtn: function confirmBtn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var msg, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.status == true && _this.replyInput === "")) {
                _context.next = 4;
                break;
              }
              _this.$message({
                type: "warning",
                message: "请输入回复内容"
              });
              _context.next = 9;
              break;
            case 4:
              //执行接口保存
              msg = {
                id: _this.form.id,
                reply_content: _this.replyInput,
                reply_status: _this.status == true ? 3 : 2
              };
              _context.next = 7;
              return suggestReply(msg);
            case 7:
              res = _context.sent;
              if (res.code === 0) {
                _this.$message({
                  type: "success",
                  message: "回复内容，保存成功"
                });
                _this.$emit("backBtn", false);
              } else {
                _this.$message({
                  type: "error",
                  message: "回复内容，保存失败"
                });
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.replyInput = "";
  }
};